import { type ILogger } from '@cian/logger';

import { Base64 } from 'js-base64';

import { type TAdfoxBannerOnLoadData, type TAdfoxTemplatesParams } from 'shared/types/adfox';

/** Возвращает результат парсинга и декодирования параметров из бандла */
export function getParsedDecodedParams(
  { bundleName, bundleParams }: TAdfoxBannerOnLoadData,
  logger: ILogger,
): TAdfoxTemplatesParams | null {
  let parsedDecodedParams: TAdfoxTemplatesParams | null = null;

  if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
    try {
      const decodedParams = Base64.decode(bundleParams.htmlBase64);

      try {
        parsedDecodedParams = JSON.parse(decodedParams);
      } catch {
        // \p{Cc} — управляющие символы Unicode (U+0000–U+001F, U+007F–U+009F),
        // на которых падает JSON.parse. Вырезаем их перед парсингом.
        parsedDecodedParams = JSON.parse(decodedParams.replace(/\p{Cc}/gu, ''));
      }
    } catch (e) {
      let internalError: Error | null = null;

      if (e instanceof Error) {
        internalError = e;
      } else {
        const error = new Error('Неизвестная ошибка, это не инстанс Error');
        internalError = error;
      }

      logger.error(internalError, {
        domain: 'src/shared/utils/postViewAnalytics/parseDecodeParams.ts',
        errorType: 'jsonParse',
        message: 'Failed to parse decoded params',
      });
    }
  }

  return parsedDecodedParams;
}
